
import { API_BASE_URL } from "../constants";
import { apiendpoints } from "../constants/api-endpoints";
// prevent spam / loops
//let isLogging = false;

export const initGlobalErrorHandler = () => {
    // console.log("AAA :: initGlobalErrorHandler");
  window.onerror =  async function (message, source, lineno, colno, error) {
   // console.log("AAA :: initGlobalErrorHandler window.onerror");
   // isLogging=false;
    const payload = {
      message: String(message),
      stackTrace: error?.stack || null,
      source: source || "window.onerror",

    //   // location
    //   pageUrl: window.location.href,

    //   // browser info
    //   browser: navigator.userAgent,

    //   // user/session (if available)
    //   userId: localStorage.getItem("userId"),
    //   sessionId: sessionStorage.getItem("sessionId"),

    //   // debug
    //   correlationId: getCorrelationId(),

    //   createdAt: new Date().toISOString()
    };

   await sendLog(payload);
   // console.log("Added logs")    ;
        
    window.location.href = "/error-page";
    // isLogging = false;
    return false; // allow default logging in console
  };


window.onunhandledrejection = async function (event) {

  const payload = {
    message: event.reason?.message || "Unhandled Promise Rejection",
    stackTrace: event.reason?.stack || null,
    source: "unhandledrejection",

    // pageUrl: window.location.href,
    // browser: navigator.userAgent,

    // correlationId: Math.random().toString(36),

    // createdAt: new Date().toISOString()
  };

  await sendLog(payload);


   window.location.href = "/error-page";
   return false;
};
};

const sendLog = async (payload) => {

  try {
    await fetch( `${API_BASE_URL}${apiendpoints.ERROR_LOG}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    });
  } catch {
    // swallow errors to avoid infinite loop
  } finally {
 //isLogging = false;
  }
};